import request from '@/utils/request';
export function pushScenarioResource(data) {
  return request.post('admin/scene/push-scenario/resource', data);
}
export function messageList(data) {
  return request.post('admin/message/list', data);
}